
import { NotaFiscalDevolucao } from "app/types/pesquisa-orcamento/consultas/Devolucoes";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import globalMU from "globalMU";
import React from "react";

export type DevolucoesOrcamentoProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    devolucoes: NotaFiscalDevolucao[]
    mostrarDetalhesDevolucoes: boolean
    devolucoesSelecionada: Partial<NotaFiscalDevolucao>
    onSelecionarMostrarDevolucoes: (mostrar: boolean, devolucao: NotaFiscalDevolucao) => void
};

export const DevolucoesOrcamento = (props: DevolucoesOrcamentoProps) => {

    const cabecalho =
        <div className="_my-2"
            id="DevolucoesOrcamento_divCabecalho"
        >
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Filial}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.NumeroPedido}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cliente</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.RazaoSocialCliente}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Vendedor</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Vendedor}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.orcamentoSelecionado.DataPedido)}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Valor</label>
                <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(props.orcamentoSelecionado.ValorPedido, 2, true)}</p>
            </div>
        </div>

    const tipoDevolucao = (devolucao: NotaFiscalDevolucao) => {
        return <>

            <div id="DevolucoesOrcamento_Div_TipoDevolucao">
                <div className="_my-3 _w-full _bg-[#f5f5f5] _mb-0 _py-3 _px-4  _rounded-t-lg _border _border-gray-300 _font-semibold">
                    <h4>
                        <label className="hover:_cursor-pointer hover:_text-[#409fff]" onClick={() => props.onSelecionarMostrarDevolucoes(!props.mostrarDetalhesDevolucoes, devolucao)}
                            id="DevolucoesOrcamento_labelTipoDevolucao"
                            >
                            {
                                'Filial:' + devolucao.DescricaoFilial +
                                ' - Nota: ' + devolucao.Numero +
                                ' - Série: ' + devolucao.Serie +
                                ' - Chegada: ' + globalMU.formatDate(devolucao.DataChegada) +
                                ' - Valor: ' + globalMU.formatarValorNumerico(devolucao.ValorTotal, 2, true)
                            }
                        </label>
                    </h4>
                </div>
                {props.mostrarDetalhesDevolucoes && props.devolucoesSelecionada.Codigo == devolucao.Codigo &&
                    <div className="_bg-[#ffffff] _p-4 b _border _border-gray-300 _border-t-0"
                        id="DevolucoesOrcamento_divDetalhesDevolucao"
                    >
                        <div className="_flex _items-start">
                            <div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nota Fiscal de Saída</label>
                                    <p className="_mb-0 _p-2">{devolucao.NotaFiscalSaidaDescricao}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                                    <p className="_mb-0 _p-2">{devolucao.DescricaoFilial}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Número</label>
                                    <p className="_mb-0 _p-2">{devolucao.Numero}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Série</label>
                                    <p className="_mb-0 _p-2">{devolucao.Serie}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">TPO</label>
                                    <p className="_mb-0 _p-2">{devolucao.DescricaoTpo}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Total</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(devolucao.ValorTotal, 2, true)}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Emissão</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatDate(devolucao.DataEmissao)}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Chegada</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatDateTime(devolucao.DataChegada)}</p>
                                </div>
                                { devolucao.DataCancelamento != null && // nao mostra se estiver cancelado, validei para ficar igual ao tradorca, para cliente NAO reclamar q nao esta vindo
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Cancelamento</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatDateTime(devolucao.DataCancelamento)}</p>
                                </div>
                                }
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Frete</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(devolucao.ValorFrete, 2, true)}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Desconto</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(devolucao.ValorDesconto, 2, true)}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Despesa Inclusas</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(devolucao.ValorDespesaInclusa, 2, true)}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cliente</label>
                                    <p className="_mb-0 _p-2">{devolucao.NomeCliente}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CPF/CNPJ</label>
                                    <p className="_mb-0 _p-2">{devolucao.CpfCnpj}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Tipo</label>
                                    <p className="_mb-0 _p-2">{devolucao.TipoNFDescricao}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Chave NFe</label>
                                    <p className="_mb-0 _p-2">{devolucao.ChaveNFe}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Situação NFe</label>
                                    <p className="_mb-0 _p-2">{devolucao.SituacaoNFeDescricao}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Observação</label>
                                    <p className="_mb-0 _p-2">{devolucao.ObservacaoNFEntrada}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    }


    return (
        <div className="_mb-4"
            id="DevolucoesOrcamento_divPrincipal"
        >

            {cabecalho}

            {props.devolucoes?.map((devolucao) => {
                return tipoDevolucao(devolucao)
            })}

            {<section style={{ marginBottom: "100px" }} />}

        </div>
    )

}